import { useState } from "react";
import { Link } from "react-router-dom";
import api, { formatApiErrorDetail } from "../lib/api";
import { Brand } from "../components/Brand";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import { Loader2, ArrowLeft, MailCheck } from "lucide-react";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await api.post("/auth/forgot-password", { email });
      setSent(true);
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail) || err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-slate-50 dark:bg-slate-950 p-6">
      <div className="w-full max-w-sm">
        <Brand size="lg" className="mb-8" />
        {sent ? (
          <div className="text-center" data-testid="forgot-password-success">
            <div className="mx-auto h-12 w-12 rounded-full bg-emerald-50 flex items-center justify-center">
              <MailCheck className="h-6 w-6 text-emerald-600" />
            </div>
            <h2 className="mt-4 font-display text-xl font-bold text-slate-900 dark:text-slate-50">Check your inbox</h2>
            <p className="mt-2 text-sm text-slate-500 dark:text-slate-400">
              If that email is registered, a reset link has been sent. It expires in 1 hour.
            </p>
            <Link to="/login" className="mt-6 inline-flex items-center gap-2 text-sm font-medium text-blue-600 hover:text-blue-700">
              <ArrowLeft className="h-4 w-4" /> Back to sign in
            </Link>
          </div>
        ) : (
          <>
            <h2 className="font-display text-2xl font-bold text-slate-900 dark:text-slate-50">Reset your password</h2>
            <p className="mt-2 text-sm text-slate-500 dark:text-slate-400">
              Enter your account email and we'll send you a reset link.
            </p>
            <form onSubmit={submit} className="mt-8 space-y-5" data-testid="forgot-password-form">
              <div className="space-y-2">
                <Label htmlFor="email">Email address</Label>
                <Input id="email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} placeholder="you@tcauditors.co.za" data-testid="forgot-email-input" />
              </div>
              {error && <div className="rounded-lg bg-rose-50 border border-rose-200 px-3 py-2.5 text-sm text-rose-700">{error}</div>}
              <Button type="submit" className="w-full h-11 bg-slate-900 hover:bg-slate-800 text-white font-semibold" disabled={loading} data-testid="forgot-submit-button">
                {loading ? <Loader2 className="h-4 w-4 animate-spin" /> : "Send reset link"}
              </Button>
              <Link to="/login" className="flex items-center justify-center gap-2 text-sm font-medium text-slate-500 hover:text-slate-700">
                <ArrowLeft className="h-4 w-4" /> Back to sign in
              </Link>
            </form>
          </>
        )}
      </div>
    </div>
  );
}
